import { Currency } from 'models/Currency';
import { CurrencyConvention } from 'models/CurrencyConvention';
import { IndexList } from 'models/IndexList';
import { LegTerms } from 'models/LegTerms';
import { createAction } from 'typesafe-actions';

import { HedgingInstrumentInterestRateMode } from '../../../../../../models/HedgingInstrument/enum';
import { LegFlow } from '../../../../../../models/LegFlow';
import { PayReceiveTypes } from '../../../../../../models/PayAcceptance/enums';
import { PricerModes } from '../../../../enums';

import { MasterLegState } from '../MasterLegReducer';

export type AddFixedLegPayload = {
  pay_receive_id: PayReceiveTypes;
  leg_currency_id: Currency['currency_id'];
  master_leg_terms: MasterLegState;
  ir_indices: IndexList[];
  currencies: Currency[];
  currency_conventions: CurrencyConvention[];
  pricerType?: PricerModes;
  instrument_type_id?: HedgingInstrumentInterestRateMode;
};
export const addFixedLeg = createAction(
  'pricer/legs/addFixedLeg',
)<AddFixedLegPayload>();

export type AddFloatLegPayload = {
  pay_receive_id: PayReceiveTypes;
  leg_currency_id: Currency['currency_id'];
  master_leg_terms: MasterLegState;
  ir_indices: IndexList[];
  currencies: Currency[];
  currency_conventions: CurrencyConvention[];
  pricerType?: PricerModes;
  instrument_type_id?: HedgingInstrumentInterestRateMode;
};
export const addFloatLeg = createAction(
  'pricer/legs/addFloatLeg',
)<AddFloatLegPayload>();

export type AddFloorLegPayload = {
  pay_receive_id: PayReceiveTypes;
  leg_currency_id: Currency['currency_id'];
  master_leg_terms: MasterLegState;
  ir_indices: IndexList[];
  currencies: Currency[];
  currency_conventions: CurrencyConvention[];
  pricerType?: PricerModes;
  instrument_type_id?: HedgingInstrumentInterestRateMode;
};
export const addFloorLeg = createAction(
  'pricer/legs/addFloorLeg',
)<AddFloorLegPayload>();

export type AddIrCapLegPayload = {
  pay_receive_id: PayReceiveTypes;
  leg_currency_id: Currency['currency_id'];
  master_leg_terms: MasterLegState;
  ir_indices: IndexList[];
  currencies: Currency[];
  currency_conventions: CurrencyConvention[];
  pricerType?: PricerModes;
  instrument_type_id?: HedgingInstrumentInterestRateMode;
};
export const addIrCapLeg = createAction(
  'pricer/legs/addIrCapLeg',
)<AddIrCapLegPayload>();

export type AddInflationLegPayload = {
  pay_receive_id: PayReceiveTypes;
  leg_currency_id: Currency['currency_id'];
  master_leg_terms: MasterLegState;
  ir_indices: IndexList[];
  currencies: Currency[];
  currency_conventions: CurrencyConvention[];
  pricerType?: PricerModes;
  instrument_type_id?: HedgingInstrumentInterestRateMode;
};
export const addInflationLeg = createAction(
  'pricer/legs/addInflationLeg',
)<AddInflationLegPayload>();

export type AddScheduledPaymentsLegPayload = {
  pay_receive_id: PayReceiveTypes;
  leg_currency_id: Currency['currency_id'];
  master_leg_terms: MasterLegState;
  ir_indices: IndexList[];
  currencies: Currency[];
  currency_conventions: CurrencyConvention[];
  pricerType?: PricerModes;
  instrument_type_id?: HedgingInstrumentInterestRateMode;
};
export const addScheduledPaymentsLeg = createAction(
  'pricer/legs/addScheduledPaymentsLeg',
)<AddScheduledPaymentsLegPayload>();

export type AddCompoundingFixedLegPayload = {
  pay_receive_id: PayReceiveTypes;
  leg_currency_id: Currency['currency_id'];
  master_leg_terms: MasterLegState;
  ir_indices: IndexList[];
  currencies: Currency[];
  currency_conventions: CurrencyConvention[];
  pricerType?: PricerModes;
  instrument_type_id?: HedgingInstrumentInterestRateMode;
};
export const addCompoundingFixedLeg = createAction(
  'pricer/legs/addCompoundingFixedLeg',
)<AddCompoundingFixedLegPayload>();

export type AddPayGoLegPayload = {
  pay_receive_id: PayReceiveTypes;
  leg_currency_id: Currency['currency_id'];
  master_leg_terms: MasterLegState;
  ir_indices: IndexList[];
  currencies: Currency[];
  currency_conventions: CurrencyConvention[];
  pricerType?: PricerModes;
  instrument_type_id?: HedgingInstrumentInterestRateMode;
};
export const addPayGoLeg = createAction(
  'pricer/legs/addPayGoLeg',
)<AddPayGoLegPayload>();

export type AddPremiumLegPayload = {
  pay_receive_id: PayReceiveTypes;
  leg_currency_id: Currency['currency_id'];
  master_leg_terms: MasterLegState;
  ir_indices: IndexList[];
  currencies: Currency[];
  currency_conventions: CurrencyConvention[];
  pricerType?: PricerModes;
  instrument_type_id?: HedgingInstrumentInterestRateMode;
};
export const addPremiumLeg = createAction(
  'pricer/legs/addPremiumLeg',
)<AddPremiumLegPayload>();

export type AddCommodityFixedLegPayload = {
  pay_receive_id: PayReceiveTypes;
  leg_currency_id: Currency['currency_id'];
  master_leg_terms: MasterLegState;
  ir_indices: IndexList[];
  currencies: Currency[];
  currency_conventions: CurrencyConvention[];
  pricerType?: PricerModes;
  instrument_type_id?: HedgingInstrumentInterestRateMode;
};
export const addCommodityFixedLeg = createAction(
  'pricer/legs/addCommodityFixedLeg',
)<AddCommodityFixedLegPayload>();

export type AddCommodityFloatLegPayload = {
  pay_receive_id: PayReceiveTypes;
  leg_currency_id: Currency['currency_id'];
  master_leg_terms: MasterLegState;
  ir_indices: IndexList[];
  currencies: Currency[];
  currency_conventions: CurrencyConvention[];
  pricerType?: PricerModes;
  instrument_type_id?: HedgingInstrumentInterestRateMode;
};
export const addCommodityFloatLeg = createAction(
  'pricer/legs/addCommodityFloatLeg',
)<AddCommodityFloatLegPayload>();

export type AddCommodityCallLegPayload = {
  pay_receive_id: PayReceiveTypes;
  leg_currency_id: Currency['currency_id'];
  master_leg_terms: MasterLegState;
  ir_indices: IndexList[];
  currencies: Currency[];
  currency_conventions: CurrencyConvention[];
  pricerType?: PricerModes;
  instrument_type_id?: HedgingInstrumentInterestRateMode;
};
export const addCommodityCallLeg = createAction(
  'pricer/legs/addCommodityCallLeg',
)<AddCommodityCallLegPayload>();

export type AddCommodityPutLegPayload = {
  pay_receive_id: PayReceiveTypes;
  leg_currency_id: Currency['currency_id'];
  master_leg_terms: MasterLegState;
  ir_indices: IndexList[];
  currencies: Currency[];
  currency_conventions: CurrencyConvention[];
  pricerType?: PricerModes;
  instrument_type_id?: HedgingInstrumentInterestRateMode;
};
export const addCommodityPutLeg = createAction(
  'pricer/legs/addCommodityPutLeg',
)<AddCommodityPutLegPayload>();

export type UpdateLegTermsStateFromFormPayload = {
  data: Partial<LegTerms>;
  legNumber: number | string;
};
export const updateLegTermsStateFromForm = createAction(
  'pricer/legs/updateLegTermsStateFromForm',
)<UpdateLegTermsStateFromFormPayload>();

export type UpdateAllLegTermsStateFromFormPayload = {
  data: Partial<LegTerms>;
};
export const updateAllLegTermsStateFromForm = createAction(
  'pricer/legs/updateAllLegTermsStateFromForm',
)<UpdateAllLegTermsStateFromFormPayload>();

export type updateAllLegFlowsPayload = {
  legNumber: number | string;
  flows: LegFlow[];
};
export const updateAllLegFlows = createAction(
  'pricer/flows/updateAllLegFlows',
)<updateAllLegFlowsPayload>();
